module.exports = __webpack_public_path__ + "img/smg.187353c4.webp";